import { useMutation } from '@tanstack/react-query'

import { setOnboarding } from './customerService'

export function useSetOnboarding() {
  return useMutation({
    mutationFn: ([task, state]: ['smartPhotoSearchBanner', boolean]) =>
      setOnboarding(task, state),
  })
}
